
<div class="row m-0">
    <div class="col-md-6 col-12 head-top">
        <!-- New code of request money card -->
        <!-- <div class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
            <div class="d-flex justify-content-between align-items-center p-3">
                <div class="gilroy-bold pt-1 sm-10 color-blue">
                    <img src="assets/images/req-money-blue.PNG" alt="" class="mr-1" width="24px">
                    <span class="sm-10 primary-text">Request Money</span>
                </div>
                <div class="lightGrey-text sm-10">
                    January 15th, 2020, 1.00 PM
                </div>
                <div class="primary-text font-weight-bold sm-10">
                    PENDING
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 align-items-center">
                <div class="sm-12 color-blue gilroy-bold"><span class="secondary-text">You requested</span> 200.00 USD <span class="secondary-text">from </span> <span class="color-blue font-weight-bold">Nicholay</span></div>
            </div>
        </div> -->
        <!-- <div class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
            <div class="d-flex justify-content-between align-items-center p-3">
                <div class="gilroy-bold pt-1 sm-10 color-green">
                    <img src="assets/images/req-money-green.PNG" alt="" class="mr-1" width="24px">
                    <span class="sm-10 green-text">Request Money</span>
                </div>
                <div class="lightGrey-text sm-10">
                    January 15th, 2020, 1.00 PM
                </div>
                <div class="text-success font-weight-bold sm-10">
                    COMPLETE
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 align-items-center">
                <div class="sm-12 secondary-text gilroy-bold"><span class="secondary-text">You received </span><span class="text-success">200.00 USD</span> from <span class="text-success font-weight-bold">Nicholay</span></div>
            </div>
        </div> -->
         <!-- New code of request money card -->
        <div class="card border-0 my-1" [ngClass]="{'selectedTab': item==requestMoneyervice.step1Data}" (click)="selectReceivingMethod(item)" style="padding: 17px 14px;" *ngFor="let item of requestMoneyervice.requestMethods">
            <div class="row">
                <div class="col-8">
                    <h6 class="sm-12 font-weight-bold secondary-text mb-0">{{item.bank_name}}</h6>
                    <small class="sm-10 grey-text">Account Ending in {{item.account_number.substr(item.account_number.length - 4)}}</small>
                </div>
                <div class="col-4">
                    <div class="d-flex">
                        <!-- <a class="sm-10 p-2  primary-text font-weight-bold">Edit</a> -->
                        <button class="btn select-btn sm-10 h-auto primary-text">{{item==requestMoneyervice.step1Data?'Selected':'Select'}}</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Selected Option --> 
        <!--         <div class="card border-0 selectedTab" style="padding: 17px 14px;">
            <div class="row">
                <div class="col-9">
                    <h6 class="sm-12 font-weight-bold secondary-text mb-0">Bank of Philippines</h6>
                    <small class="sm-10 secondary-text">Account Ending in 1234</small>
                </div>
                <div class="col-3 px-0">
                    <button class="btn select-btn sm-10 h-auto primary-text text-right">Selected</button>
                </div>
            </div>
        </div> -->
        <!-- Selected Option End-->
        <h5 class="primary-text font-weight-bold sm-18 mt-3">How would you like to recieve money?</h5>
        
        <app-add-request-method (onMethodAdded)="requestMoneyervice.setRequestMethods()"></app-add-request-method>
        
        <div class="div d-flex  my-5 address_field">
            <button (click)="goBack()"  type="button" class="btn transparent-btn primary-text back-btn">Cancel</button>
            <button [disabled]="!requestMoneyervice.step1Data" (click)="goNext()"  class="btn btn-primary  w-100">Next</button>
            <!-- [disabled]="!requestMoneyervice.step1Data" -->
        </div>
    </div>
    
</div>